export default __webpack_public_path__ + "static/media/AstronomySaturn_02.030de991.png";